/**
 * Icône de marque iCall CRM (monogramme « iC + onde »).
 *
 * Décorative : le nom de la marque est toujours écrit à côté (`BRAND_NAME`),
 * donc `alt=""` et `aria-hidden`. Les coins arrondis sont déjà dans le SVG
 * (`/icr-icon.svg`) : aucune tuile ni fond à ajouter autour.
 */
export interface BrandMarkProps {
  /** Côté en pixels (carré). */
  size?: number
  className?: string
}

export function BrandMark({ size = 40, className = '' }: BrandMarkProps) {
  return (
    <img
      src="/icr-icon.svg"
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      draggable={false}
      className={`shrink-0 select-none ${className}`.trim()}
      style={{ width: size, height: size }}
    />
  )
}

export default BrandMark
